import { useSuspenseQuery } from '~/services'
import type { PlanId } from './types'

export const usePlanSummary = (workspaceId: string, planId: PlanId) => {
  const { data } = useSuspenseQuery('workspaces_/$workspaceId_/billing/planSummary/$planId', {
    workspaceId,
    planId,
  })
  return { planSummary: data }
}
